'use strict';
// based on https://github.com/moul/number-to-words
const _ = require('lodash');

const integerToTriplets = nr => {
  const triplets = [];
  let number = nr;
  while (number >= 1) {
    triplets.push(number % 1000);
    number = number / 1000;
  }

  return triplets;
};

module.exports = (input) => {
  const dutchMegas = [
    '',
    'duizend',
    'miljoen',
    'miljard',
    'biljoen',
    'biljard',
    'triljoen',
    'triljard',
    'septiljoen',
    'octillion',
    'noniljoen',
    'decillion'
  ];
  const dutchUnits = [
    'nul',
    'een',
    'twee',
    'drie',
    'vier',
    'vijf',
    'zes',
    'zeven',
    'acht',
    'negen'
  ];
  const dutchTens = [
    'nul',
    'tien',
    'twintig',
    'dertig',
    'veertig',
    'vijftig',
    'zestig',
    'zeventig',
    'tachtig',
    'negentig'
  ];
  const dutchTeens = [
    'tien',
    'elf',
    'twaalf',
    'dertien',
    'veertien',
    'vijftien',
    'zestien',
    'zeventien',
    'achttien',
    'negentien'
  ];

  const words = [];

  // split integer in triplets
  const triplets = integerToTriplets(input);

  if (input === 0) {
    return 'nul';
  }

  // Error scenario: not a valid input
  if (_.size(triplets) == 0) {
    return 'Input is not a valid number.';
  }

  // iterate over triplets
  for (let i = _.size(triplets) - 1; i >= 0; i--) {
    const triplet = triplets[i];
    const tripletWords = [];
    // Do nothing for empty triplet
    if (triplet === 0) {
      continue;
    }

    // three-digits
    const hundreds = _.toInteger((triplet / 100) % 10);
    const tens = _.toInteger((triplet / 10) % 10);
    const units = _.toInteger(triplet % 10);

    switch (hundreds) {
      case 0:
        break;
      case 1:
        tripletWords.push('honderd');
        break;
      default:
        tripletWords.push(dutchUnits[hundreds] + 'honderd');
        break;
    }

    if (tens === 0 && units === 0) {
      // Do nothing
    } else {
      switch (tens) {
        case 0:
          tripletWords.push(dutchUnits[units]);
          break;
        case 1:
          tripletWords.push(dutchTeens[units]);
          break;
        default:
          if (units > 0) {
            const unit = dutchUnits[units];
            const infix = _.endsWith(unit, 'e') ? 'ën' : 'en';
            const word = unit + infix + dutchTens[tens];
            tripletWords.push(word);
          } else {
            tripletWords.push(dutchTens[tens]);
          }
          break;
      }
    }

    switch (i) {
      case 0:
        words.push(tripletWords.join(''));
        break;
      case 1:
        // remove 'een' from array
        _.pull(tripletWords, 'een');
        tripletWords.push(dutchMegas[i]);
        words.push(tripletWords.join(''));
        break;
      default:
        words.push(tripletWords.join(''));
        words.push(dutchMegas[i]);
    }
  }

  return words.join(' ');
};
